import { render, staticRenderFns } from "./RbxDrawer.vue?vue&type=template&id=06708c60&"
import script from "./RbxDrawer.vue?vue&type=script&lang=js&"
export * from "./RbxDrawer.vue?vue&type=script&lang=js&"
import style0 from "./RbxDrawer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RbxDrawer.vue"
export default component.exports